module.exports = __webpack_public_path__ + "static/assets/ff7e88e70816cb559fb00fbe15221f99.svg";